import React, { Component } from 'react';
import styled from 'styled-components';
import Notification, { INotificationProps } from './Notification';
import { INotification } from './notification.interface';

interface INotificationsListProps {
    notifications: INotification[];
    removeNotification: (id: string) => void;
}

const NotificationsListWrapper = styled.div`
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
`;

export default class NotificationsList extends Component<INotificationsListProps> {
    constructor(props: INotificationsListProps) {
        super(props);
        this.state = { notifications: props.notifications };

        this.dismissNotification = this.dismissNotification.bind(this);
    }

    public dismissNotification(notification: INotification) {
        const { removeNotification } = this.props;
        removeNotification(notification.id);
    }

    public render() {
        const { notifications } = this.props;
        const notificationsMapped = notifications.map(
            (notification: INotification, index: number) => (
                <Notification
                    key={index}
                    {...notification}
                    // tslint:disable-next-line:jsx-no-lambda
                    onDismiss={() => {
                        this.dismissNotification(notification);
                    }}
                    qaId={`notification-${index}`}
                />
            ),
        );
        return (
            <NotificationsListWrapper data-qa-id="notification-list">
                {notificationsMapped}
            </NotificationsListWrapper>
        );
    }
}
